export default __webpack_public_path__ + "static/media/step-updaterecord.1b844d48.svg";